// extracted by mini-css-extract-plugin
export var container = "Intro-module--container--16d62";
export var fadeInAnimation = "Intro-module--fadeInAnimation--191e6";
export var grayFilter = "Intro-module--grayFilter--65522";
export var image = "Intro-module--image--37d28";
export var layout = "Intro-module--layout--b8631";
export var link = "Intro-module--link--2d5d5";
export var logo = "Intro-module--logo--9c948";
export var nda = "Intro-module--nda--8647e";
export var ndaLogoText = "Intro-module--ndaLogoText--6fa43";
export var ndaText = "Intro-module--ndaText--e62fb";
export var ndaWrapper = "Intro-module--ndaWrapper--244cf";
export var picture = "Intro-module--picture--958c8";
export var reviewCard = "Intro-module--reviewCard--57f0f";
export var tagsRow = "Intro-module--tagsRow--7f26b";
export var title = "Intro-module--title--e123c";
export var titleLeft = "Intro-module--titleLeft--9c745";
export var titleRow = "Intro-module--titleRow--3cc8e";
export var withoutReview = "Intro-module--withoutReview--9189f";